import * as THREE from 'three';
import { createRng, randomCharacter } from '@kokun/shared';

const MENU_EMOTES = ['dance', 'wave', 'laugh', 'chicken', 'flex', 'facepalm'];
import { Avatar } from '../characters/avatar';
import type { World3D } from './world3d';

/** Fondo animado del menú: personajes haciendo el tonto en la plaza y cámara en órbita lenta. */
export class MenuScene {
  private avatars: Avatar[] = [];
  private off: () => void;
  private t = 0;

  constructor(private w: World3D) {
    const rng = createRng(Date.now() & 0xffff);
    const emotes = ['dance', 'wave', 'laugh', 'chicken', 'flex', 'dance'];
    for (let i = 0; i < 6; i++) {
      const a = new Avatar(randomCharacter(rng));
      const ang = (i / 6) * Math.PI * 2;
      a.root.position.set(Math.cos(ang) * 6, 0, Math.sin(ang) * 6 + 2);
      a.root.rotation.y = Math.atan2(Math.cos(ang), Math.sin(ang)) + Math.PI / 2;
      a.state = `emote:${emotes[i]}`;
      this.avatars.push(a);
      w.dynamic.add(a.root);
    }
    w.input.enabled = false;
    w.engine.shadowTarget = new THREE.Vector3(0, 0, 2);
    this.off = w.engine.onFrame((dt) => this.update(dt));
  }

  private update(dt: number) {
    this.t += dt;
    const cam = this.w.engine.camera;
    const a = this.t * 0.08;
    cam.position.set(Math.sin(a) * 17, 6.5 + Math.sin(this.t * 0.3), Math.cos(a) * 17 + 2);
    cam.lookAt(0, 1.6, 2);
    this.avatars.forEach((av, i) => {
      // Cada pocos segundos cambian de gesto o dan un salto
      const phase = Math.floor((this.t + i * 1.7) / 4);
      av.state = `emote:${MENU_EMOTES[(phase + i) % MENU_EMOTES.length]}`;
      if ((phase + i) % 5 === 0) {
        av.root.position.y = Math.max(0, Math.sin(((this.t + i * 1.7) % 4) * Math.PI * 0.8) * 1.2);
        av.state = av.root.position.y > 0.05 ? 'jump' : av.state;
      } else av.root.position.y = 0;
      av.update(dt);
    });
  }

  dispose() {
    this.off();
    for (const a of this.avatars) {
      this.w.dynamic.remove(a.root);
      a.dispose();
    }
    this.avatars = [];
  }
}
